import { useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), app_url: window.location.origin }),
        cache: 'no-store',
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
        throw new Error(err.detail || `HTTP ${res.status}`);
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: 'var(--color-bg-content)' }}>
      <div className="card shadow-sm" style={{ width: '100%', maxWidth: 420 }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <i className="bi bi-lightning-charge-fill text-warning fs-1" />
            <h4 className="mt-2 fw-bold">MK Workout</h4>
            <p className="text-muted small">Passwort zurücksetzen</p>
          </div>

          {submitted ? (
            <div className="text-center">
              <div className="alert alert-success">
                <i className="bi bi-envelope-check me-2" />
                Falls diese E-Mail-Adresse registriert ist, wurde eine Nachricht mit dem Reset-Link gesendet.
              </div>
              <p className="text-muted small">Bitte prüfe auch deinen Spam-Ordner.</p>
              <Link to="/login" className="btn btn-outline-secondary mt-2">
                <i className="bi bi-arrow-left me-1" />
                Zurück zur Anmeldung
              </Link>
            </div>
          ) : (
            <>
              {error && <div className="alert alert-danger py-2 small">{error}</div>}
              <p className="text-muted small mb-3">
                Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen deines Passworts.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">E-Mail</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                    placeholder="deine@email.de"
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100 mb-3" disabled={loading}>
                  {loading ? (
                    <><span className="spinner-border spinner-border-sm me-2" />Senden…</>
                  ) : (
                    <><i className="bi bi-envelope me-1" />Reset-Link senden</>
                  )}
                </button>
                <div className="text-center">
                  <Link to="/login" className="text-muted small">
                    <i className="bi bi-arrow-left me-1" />Zurück zur Anmeldung
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
